/*=========================================================================================
  File Name: moduleRequestTypeConfigGetters.js
  Description: Request Type Config Module Getters
==========================================================================================*/
import constant from "@/utils/constant.js";

const formatControls = (controls = []) =>
	controls.map(control => ({
		...control,
		description: {
			...control.description,
			position: control.description.position || constant.DYNAMIC_FORM_FIELD_INFO_POSITION.BOTTOM
		},
		children: typeof control.children === "string" ? JSON.parse(control.children) : control.children
	}));

export default {
	getParentStepData: state => ({
		...state.requestType,
		controls: formatControls(state.requestType.controls || [])
	}),
	getChildStepsData: state =>
		(state.requestType.statuses || []).map(step => ({
			...step,
			controls: formatControls(step.controls || [])
		}))
};
